import { Dispatch } from 'redux';
import { getClaimByResellerClaimNumber } from '../../clients/HrpsClaimsApi';
import { GetClaimByResellerClaimNumberOutput } from '../../types';
import { ClaimWithMetadata } from '../types';
import { DETAILED_CLAIM_GET, DETAILED_CLAIM_LOADED, DetailedClaimActions } from './detailedClaimActions';

export function getDetailedClaimLoading(): DetailedClaimActions {
    return {
        type: DETAILED_CLAIM_GET,
        payload: {
            status: 'Loading',
            error: undefined,
            value: undefined,
        },
    };
}

export function getDetailedClaimLoaded(fullClaim: ClaimWithMetadata): DetailedClaimActions {
    return {
        type: DETAILED_CLAIM_LOADED,
        payload: {
            status: 'Loaded',
            error: undefined,
            value: fullClaim,
        },
    };
}

export function getDetailedClaimFailed(error: any): DetailedClaimActions {
    return {
        type: DETAILED_CLAIM_LOADED,
        payload: {
            status: 'Failed',
            error,
            value: undefined,
        },
    };
}

export function getDetailedClaim(resellerId: string, resellerClaimNumber: string) {
    return (dispatch: Dispatch) => {
        dispatch(getDetailedClaimLoading());
        return getClaimByResellerClaimNumber({ resellerId, resellerClaimNumber })
            .then((result: GetClaimByResellerClaimNumberOutput) => {
                const fullClaim: ClaimWithMetadata = {
                    detailedClaim: result.claimDetails,
                    claimMetadata: result.metadata,
                };
                dispatch(getDetailedClaimLoaded(fullClaim));
            })
            .catch((err: any) => {
                dispatch(getDetailedClaimFailed(err));
            });
    };
}
